import React from 'react';

export default function SWHome() {

    let content = (<div className="welcomeScreen">
        <div className="welcome">
            <h1>Welcome to Stormwater document share</h1>
            <div className="font-bold">To access your documents use the link provided in your email.</div>
        </div>
    </div>);

    return (content);
}
